<template>
    <div class="tags " width="80" style="max-width:80px">
        <div class="tag " :class="{'is-success' : order.embroidery_complete == 1}" v-if="order.requires_embroidery==1 || order.order_embroidery==1">Embroidery</div>
        <div class="tag "  :class="{'is-success' : order.silicon_complete == 1}" v-if="order.requires_silicon_stripes==1">Silicon</div>
        <div class="tag "  :class="{'is-success' : order.garmentname.includes('xxxx')}" v-if="order.requires_embossing==1">Embossing</div>
        <div class="tag "  :class="{'is-success' : order.knitted_trim_complete == 1, 'is-warning' : order.knitted_trim_complete == 0 && order.knit_complete == 1}" v-if="order.requires_knitted_trim==1">Knitted Trim</div>
        <div class="tag "  :class="{'is-success' : order.garmentname.includes('xxxx')}" v-if="order.requires_dtf==1">DTF</div>
        <div class="tag "  :class="{'is-success' : order.garmentname.includes('xxxx')}" v-if="order.requires_gps_pockets==1">GPS</div>
    </div>
</template>

<script>
export default {
  name: 'OrderExtras',
  props: ['order'],
  components: {
  }
}
</script>
